import { useMemo } from 'react';
import { Colors } from '../../../../../../themes/colors';
import { EditableField } from '../../../../../commonComponents/EditableField';
import { MultiCheckboxGroup } from '../../../../../commonComponents/MultiCheckboxGroup';
import { expectedDaysOptions, JobStatus, scheduleTypeOptions } from '../../../shared/constants';
import { FormCard } from '../../../shared/FormCard';
import { InfoRow } from '../../../shared/InfoRow';
import { getDayNameByCode } from '../../../shared/utils';

export const ScheduleInformationCard = ({
  formValues,
  isEditing,
  job,
  handleChange,
  onCancelClick,
  onEditClick,
  onSaveClick,
}) => {
  const isFormValid = useMemo(() => !!formValues.scheduleType, [formValues.scheduleType]);

  return (
    <FormCard title="Schedule" style={{ marginTop: '16px' }}>
      <div>
        <InfoRow>
          <span className="semi-bold">
            Schedule Type{isEditing && <span style={{ color: Colors.error_500 }}>*</span>}:
          </span>
          <EditableField
            editing={isEditing}
            view={<span>{job?.scheduleType || '-'}</span>}
            edit={
              <select
                className="custom-select custom-select-lg"
                style={{ height: 32, width: 180 }}
                value={formValues.scheduleType}
                onChange={(val) => handleChange('scheduleType', val.target.value)}
              >
                {scheduleTypeOptions.map((option) => (
                  <option key={option.code} value={option.code}>
                    {option.name}
                  </option>
                ))}
              </select>
            }
          />
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Expected Days:</span>
          <EditableField
            editing={isEditing}
            view={
              <span style={{ maxWidth: '80%', textAlign: 'right' }}>
                {job?.expectedDays?.length
                  ? job.expectedDays.map(getDayNameByCode).join(', ')
                  : '-'}
              </span>
            }
            edit={
              <div style={{ maxWidth: '80%' }}>
                <MultiCheckboxGroup
                  style={{ justifyContent: 'flex-end' }}
                  options={expectedDaysOptions.map((option) => ({
                    label: option.name,
                    value: option.code,
                  }))}
                  selectedValues={formValues.expectedDays || []}
                  onChange={(updated) => handleChange('expectedDays', updated)}
                />
              </div>
            }
          />
        </InfoRow>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
        {isEditing ? (
          <div style={{ display: 'flex', alignSelf: 'center', gap: 10 }}>
            <button
              type="button"
              className="btn btn-danger"
              style={{ width: 100 }}
              onClick={onCancelClick}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-info"
              style={{ width: 100 }}
              onClick={onSaveClick}
              disabled={!isFormValid}
            >
              Save
            </button>
          </div>
        ) : (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {![JobStatus.CLOSED, JobStatus.SUSPENDED].includes(job?.status) && (
              <button
                type="button"
                className="btn btn-info"
                style={{ width: 150, alignSelf: 'center' }}
                onClick={onEditClick}
              >
                Edit
              </button>
            )}
          </>
        )}
      </div>
    </FormCard>
  );
};
